module.exports = __webpack_public_path__ + "img/ruby.be5030ca.webp";